module.exports = __webpack_public_path__ + "static/img/13.12dbf9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/13.png
// module id = NhAL
// module chunks = 0